<header class="bg-main-blue-light h-screen w-full relative overflow-hidden">
  <!-- navbar layer -->
  <app-lite-navbar></app-lite-navbar>

  <!-- sport images: hidden on mobile (below sm), anchored to viewport on sm+ -->
  <img
    src="hero_image/basketball.png"
    alt="Hero Section Basketball"
    class="hidden sm:block absolute z-10 object-contain animate-move-in-down pointer-events-none sm:top-[12vh] sm:left-[3vw] sm:w-[15vw] sm:h-[15vw] lg:top-[10vh] lg:left-[10vw] lg:w-[11vw] lg:h-[11vw]"
  />
  <img
    src="hero_image/tennis.png"
    alt="Hero Section Tennis"
    class="hidden sm:block absolute z-30 object-contain animate-move-in-left pointer-events-none sm:bottom-[9vh] sm:left-[36vw] sm:w-[10vw] sm:h-[10vw] lg:bottom-[10vh] lg:left-[32vw] lg:w-[7vw] lg:h-[7vw]"
  />
  <img
    src="hero_image/basketball.png"
    alt="Hero Section Basketball"
    class="sm:hidden block absolute z-10 object-contain animate-move-in-down pointer-events-none w-[20vw] h-[20vw] top-[10vh] left-[28vw]"
  />
  <img
    src="hero_image/tennis.png"
    alt="Hero Section Tennis"
    class="sm:hidden block absolute z-30 object-contain animate-move-in-left pointer-events-none w-[14vw] h-[14vw] bottom-[52vh] right-[30vw]"
  />

  <div class="h-full w-full pt-10 sm:pt-0">
    <!-- text layer -->
    <div class="w-full h-full flex flex-col sm:flex-row items-center sm:gap-0">
      <div class="w-full sm:w-1/2 h-1/2 sm:h-full flex items-center justify-center">
        <div class="relative w-full h-full">
          <img
            src="lite/hero/lite_mobile.png"
            alt="Lite Hero Section Mobile"
            class="absolute z-20 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-52 h-52 sm:w-[600px] sm:h-[600px] sm:-translate-y-4/9 object-contain"
          />
        </div>
      </div>
      <div
        class="flex flex-col w-full sm:w-1/2 items-center sm:items-start justify-center sm:justify-start px-6"
      >
        <h1
          i18n="lite.hero|Publish your game headline@@lite.hero.headline1"
          class="text-3xl sm:text-5xl font-bold text-white tracking-wide animate-fade-in-up text-center sm:text-left text-shadow-[0px_0px_10px_rgba(0,0,0,0.5)]"
        >
          Publish Your Game
        </h1>

        <h1
          i18n="lite.hero|For free headline@@lite.hero.headline2"
          class="text-3xl sm:text-5xl font-bold text-white tracking-wide animate-fade-in-up text-center sm:text-left text-shadow-[0px_0px_10px_rgba(0,0,0,0.5)]"
        >
          For Free!
        </h1>

        <div class="flex flex-col sm:flex-row flex-wrap items-stretch gap-2 sm:gap-4 mt-5">
          <button
            class="border text-sm text-white px-5 py-2.5 rounded-full font-light cursor-pointer flex items-start justify-start gap-2 animate-fade-in-up-delay-2"
          >
            <span><img src="check_white.svg" alt="Check White" class="w-6 h-6" /></span>
            <span
              i18n="lite.hero|Manage easily badge@@lite.hero.manageEasily"
              class="font-semibold text-shadow-[0px_0px_10px_rgba(0,0,0,0.5)]"
              >Manage Easily</span
            >
          </button>
          <button
            class="border text-sm text-white px-5 py-2.5 rounded-full font-light cursor-pointer flex items-start justify-start gap-2 animate-fade-in-up-delay-2"
          >
            <span><img src="check_white.svg" alt="Check White" class="w-6 h-6" /></span>
            <span
              i18n="lite.hero|Joining easily badge@@lite.hero.joiningEasily"
              class="font-semibold text-shadow-[0px_0px_10px_rgba(0,0,0,0.5)]"
              >Joining Easily</span
            >
          </button>
          <button
            class="border text-sm text-white px-5 py-2.5 rounded-full font-light cursor-pointer flex items-start justify-start gap-2 animate-fade-in-up-delay-2"
          >
            <span><img src="check_white.svg" alt="Check White" class="w-6 h-6" /></span>
            <span
              i18n="lite.hero|Free badge@@lite.hero.free"
              class="font-semibold text-shadow-[0px_0px_10px_rgba(0,0,0,0.5)]"
              >Free</span
            >
          </button>
        </div>
        <!-- <button
          class="w-full sm:w-fit bg-white text-sm mt-5 sm:mt-10 text-main-blue-light px-5 py-2.5 rounded-full font-light cursor-pointer flex items-center justify-center gap-2 animate-fade-in-up-delay-2 hover:bg-main-yellow hover:text-white hover:border-0 transition-all duration-300 active:scale-95"
        >
          <span i18n="lite.hero|Let's find out button@@lite.hero.letsFindOut">Let's Find Out</span>
          <span
            ><img src="open_in_new_blue.svg" alt="Open in new tab" class="w-4 h-4 inline-block"
          /></span>
        </button> -->
        <button
          class="w-full sm:w-fit bg-white/70 text-sm mt-5 sm:mt-10 text-main-blue-light px-5 py-2.5 rounded-full font-light cursor-pointer flex items-center justify-center gap-2"
        >
          <span i18n="lite.hero|Coming soon button@@lite.hero.comingSoon">Coming Soon</span>
        </button>
      </div>
    </div>
  </div>
  <!-- dropdown layer -->
  <div class="absolute bottom-0 right-0 w-full flex items-center justify-center sm:pb-10 z-20">
    <button class="cursor-pointer hover:scale-110 transition-all duration-300 active:scale-95">
      <img src="dropdown.svg" alt="Dropdown" class="sm:w-10 sm:h-10 w-8 h-8 animate-bounce" />
    </button>
  </div>
</header>
